module.exports = __webpack_public_path__ + "img/emir-pretnar-croatia-shukokai.e9d9045b.jpg";